import { apiGet, apiPost, apiPut } from '@gat-ship/lib'
import type {
  GetAllSupportPersonnelResponse,
  GetSupportSessionResponse,
  GetAssignedSupportSessionRequest,
  GetRegisteredSupportSessionRequest,
  GetSupporSessionsHistoryQueryParams,
  GetSupporSessionsHistoryRequest,
  CreateNewSupportSessionRequest
} from '@gat-ship/types'
import { SUPPORT_API_PATHS } from '@gat-ship/types'

/** Get a support session by ID that is either registered by or assigned to the current user. */
export async function getAllSupportPersonnelRequest() {
  const response = await apiGet<GetAllSupportPersonnelResponse>(
    SUPPORT_API_PATHS.getAllSupportPersonnel
  )
  return response
}

export async function getSupporSessionRequest(sessionId: string) {
  const response = await apiGet<GetSupportSessionResponse>(
    SUPPORT_API_PATHS.getSupportSession(sessionId)
  )
  return response
}

/** Get active support sessions that are assigned to the current user. */
export async function getAssignedSupportSessionsRequest() {
  const response = await apiGet<GetAssignedSupportSessionRequest>(
    SUPPORT_API_PATHS.getAssignedSupportSessions
  )
  return response
}

/** Get active support sessions that are registered by the current user. */
export async function getRegisteredSupportSessionsRequest() {
  const response = await apiGet<GetRegisteredSupportSessionRequest>(
    SUPPORT_API_PATHS.getRegisteredSupportSessions
  )
  return response
}

/** Get the history of support sessions. */
export async function getSupporSessionsHistoryRequest(
  query?: GetSupporSessionsHistoryQueryParams
) {
  const response = await apiGet<GetSupporSessionsHistoryRequest>(
    SUPPORT_API_PATHS.getSupporSessionsHistory(query)
  )
  return response
}

/** Creates a new support session and assign it to a given support user. */
export async function createNewSupportSessionRequest(
  payload: CreateNewSupportSessionRequest,
  commandId: string
) {
  const response = await apiPost(
    SUPPORT_API_PATHS.createNewSupportSession,
    payload,
    commandId
  )
  return response
}

/** Ends an existing support session. */
export async function endSupportSessionRequest(
  sessionId: string,
  commandId: string
) {
  const response = await apiPut(
    SUPPORT_API_PATHS.endSupportSession(sessionId),
    {},
    commandId
  )
  return response
}
